import { ImportsListContainer } from '@/modules/ProductsImport';

const ImportsList = (): JSX.Element => <ImportsListContainer />;

export default ImportsList;
